import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  ApiErrorResponse,
  ApiResponse,
  IProductResponse,
  Product,
  ENV,
  IEnvironment,
  IExternalProductResponse,
  CurrencyType,
  Translated,
  ApiBanK
} from '@shabic/models';

@Injectable({ providedIn: 'root' })
export class ProductBankProductService extends ApiBanK {
  constructor(
    private http: HttpClient,
    @Inject(ENV) env: IEnvironment
  ) {
    super(env);
  }

  getProductByBarCode(barCode: string): Observable<ApiResponse<Product | ApiErrorResponse>> {
    return this.http
      .get<IExternalProductResponse>(this.getApiEndpoint(`/bank/products/${barCode}`))
      .pipe(
        map(response => {
          const transformedResponse: IProductResponse = {
            nameFirst: response.name || '',
            nameSecond: response.nameArabic || '',
            descriptionFirst: response.description || '',
            descriptionSecond: response.descriptionArabic || '',
            code: response.productCode,
            barCode: response.barCode,
            govtProductCode: response.govtProductCode,
            country: response.countryOfOrigin || 'Saudi Arabia',
            categoryId: response.category?.id,
            category: response.category,
            status: response.status,
            company: response.company,
            medias: response.medias,
            currencyFirst: (response.currencyFirst || 'USD') as CurrencyType,
            currencySecond: (response.currencySecond || 'USD') as CurrencyType,
            priceFirst: response.priceFirst,
            priceSecond: response.priceSecond,
            vat: response.vat,
            food: response.food,
            specialHandling: response.specialHandling,
            brand: response.brand,
            color: response.color,
            attributes: {
              weight: response.attributes.weight,
              dimension: response.attributes.dimension,
              typeOfPackaging: response.attributes.typeOfPackaging,
              packing: response.attributes.packing,
              packingSecond: response.attributes.packingSecond,
              measurement: response.attributes.measurement,
              measurementSecond: response.attributes.measurementSecond,
              packingQuantity: response.attributes.packingQuantity
            }
          };

          const product = new Product(transformedResponse);
          product.name = new Translated<string>(
            Translated.prepareConfig({
              en: response.name || '',
              ar: response.nameArabic || ''
            })
          );

          return new ApiResponse(product);
        }),
        catchError(error => of(new ApiResponse(new ApiErrorResponse(error))))
      );
  }
} 